(() => {
  if (window.beadifiqueReviewsReady) return;
  window.beadifiqueReviewsReady = true;
  const instances = new WeakMap();
  const selector = '[data-beadifique-reviews]';
  const reveal = (top, bottom) => {
    const viewport = window.visualViewport;
    const viewportTop = (viewport?.offsetTop || 0) + 24;
    const viewportBottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight) - 24;
    const delta = top < viewportTop ? top - viewportTop : bottom > viewportBottom ? bottom - viewportBottom : 0;
    if (Math.abs(delta) > 1) window.scrollBy({top: delta, behavior: 'instant'});
  };
  const configureForms = () => {
    const app = window.jdgm;
    if (typeof app?.openForm !== 'function' || app.openForm.beadifiqueSteady) return;
    const originalOpen = app.openForm;
    const originalClose = app.closeForm;
    app.openForm = function (widget) {
      const element = widget?.[0];
      const wrapper = element?.querySelector('.jdgm-form-wrapper');
      if (!element?.closest(selector) || !wrapper) return originalOpen.apply(this, arguments);
      app.closeQuestionForm?.(widget);
      app.$(wrapper).stop(true, true).show();
      app.toggleWriteReviewLink(widget, true);
      if (window.jdgmSettings?.widget_show_review_title_input === false) {
        const titleField = wrapper.querySelector('input[name="review_title"]')?.closest('.jdgm-form__fieldset, .jdgm-form__title-fieldset');
        if (titleField) titleField.style.display = 'none';
      }
      const rating = wrapper.querySelector('.jdgm-form__rating [tabindex="0"]');
      const firstField = wrapper.querySelector('input[type="text"]');
      (rating || firstField)?.focus({preventScroll: true});
      const title = wrapper.querySelector('.jdgm-form__title') || wrapper;
      const start = title.getBoundingClientRect();
      const end = (rating?.closest('.jdgm-form__fieldset') || title).getBoundingClientRect();
      reveal(start.top, end.bottom);
    };
    app.openForm.beadifiqueSteady = true;
    if (typeof originalClose === 'function') app.closeForm = function (widget) {
      const element = widget?.[0];
      const wrapper = element?.querySelector('.jdgm-form-wrapper');
      if (!element?.closest(selector) || !wrapper) return originalClose.apply(this, arguments);
      const returnFocus = wrapper.contains(document.activeElement) || element.querySelector('.jdgm-write-rev-link') === document.activeElement;
      app.$(wrapper).stop(true, true).hide();
      app.toggleWriteReviewLink(widget, false);
      if (returnFocus) {
        const button = element.querySelector('.jdgm-write-rev-link');
        button?.focus({preventScroll: true});
        if (button) {
          const rect = button.getBoundingClientRect();
          reveal(rect.top, rect.bottom);
        }
      }
    };
  };
  const rootsIn = (scope) => scope.matches?.(selector) ? [scope] : scope.querySelectorAll(selector);
  const initialize = (scope) => {
    rootsIn(scope).forEach((root) => {
      if (instances.has(root)) return;
      let frame = 0;
      const observe = () => observer.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-average-rating', 'data-number-of-reviews']
      });
      const update = () => {
        frame = 0;
        observer.disconnect();
        root.querySelectorAll('.jdgm-review-widget').forEach((widget) => {
          widget.dataset.notScrollTo = 'true';
          window.jdgm?.$?.(widget).data('not-scroll-to', true);
        });
        configureForms();
        root.querySelectorAll('.jdgm-rev-widg').forEach((widget) => {
          const count = Number(widget.dataset.numberOfReviews);
          const rating = Number(widget.dataset.averageRating);
          const summary = widget.querySelector('.jdgm-rev-widg__summary-inner');
          if (summary && count > 0 && Number.isFinite(rating)) {
            let score = summary.querySelector('.bf-review-score');
            if (!score) {
              score = document.createElement('div');
              score.className = 'bf-review-score';
              score.setAttribute('aria-hidden', 'true');
              const value = document.createElement('strong');
              const scale = document.createElement('span');
              scale.textContent = '/ 5';
              score.append(value, scale);
              summary.prepend(score);
            }
            score.querySelector('strong').textContent = rating.toLocaleString(document.documentElement.lang || 'en', {minimumFractionDigits: 1, maximumFractionDigits: 1});
            widget.classList.add('bf-review-has-score');
          } else {
            summary?.querySelector('.bf-review-score')?.remove();
            widget.classList.remove('bf-review-has-score');
          }
          const actions = widget.querySelector('.jdgm-row-actions');
          if (actions && Number.isFinite(count) && count > 0) {
            let countLabel = actions.querySelector('.bf-review-count');
            if (!countLabel) {
              countLabel = document.createElement('span');
              countLabel.className = 'bf-review-count';
              actions.prepend(countLabel);
            }
            const template = count === 1 ? root.dataset.bfReviewCountOne : root.dataset.bfReviewCountOther;
            countLabel.textContent = (template || '').replace('[count]', count.toLocaleString(document.documentElement.lang || 'en'));
          }
          widget.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach((row) => {
            const ratingNumber = Number(row.dataset.rating);
            const stars = row.querySelector('.jdgm-histogram__star');
            if (!stars || ratingNumber < 1 || ratingNumber > 5 || stars.querySelector('.bf-review-rating-number')) return;
            const number = document.createElement('span');
            number.className = 'bf-review-rating-number';
            number.setAttribute('aria-hidden', 'true');
            number.textContent = String(ratingNumber);
            stars.prepend(number);
          });
          widget.querySelectorAll('.jdgm-rev__replier-wrapper').forEach((reply) => {
            reply.childNodes.forEach((node) => {
              if (node.nodeType === Node.TEXT_NODE && /^\s*>>/.test(node.textContent)) node.textContent = node.textContent.replace(/^\s*>>\s*/, '');
            });
          });
          widget.querySelectorAll('.jdgm-picture-fieldset__box--input .jdgm-picture-fieldset__box-wrapper').forEach((box) => {
            if (box.querySelector('.bf-review-upload-label')) return;
            const label = document.createElement('span');
            label.className = 'bf-review-upload-label';
            label.setAttribute('aria-hidden', 'true');
            label.textContent = root.dataset.bfReviewUpload;
            box.append(label);
          });
        });
        observe();
      };
      const observer = new MutationObserver(() => {
        if (!frame) frame = requestAnimationFrame(update);
      });
      instances.set(root, () => {
        observer.disconnect();
        cancelAnimationFrame(frame);
        instances.delete(root);
      });
      update();
    });
  };
  initialize(document);
  document.addEventListener('jdgm.doneSetupReviewForm', configureForms);
  document.addEventListener('jdgm.doneSetup', configureForms);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    rootsIn(event.target).forEach((root) => instances.get(root)?.());
  });
})();

